import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonItem, IonLabel } from '@ionic/angular/standalone';

@Component({
  selector: 'crowdctrl-board-item',
  standalone: true,
  imports: [CommonModule, IonItem, IonLabel],
  templateUrl: './board-item.component.html',
  styleUrl: './board-item.component.css',
})
export class BoardItemComponent {
  @Input() boardName!: string;
  @Input() description?: string;
  @Input() button = false;
  @Input() detail = false;
  @Input() lines?: string;
  @Output() click = new EventEmitter<void>();

  onItemClick(): void {
    this.click.emit();
  }
}
